module.exports = __webpack_public_path__ + "static/media/Перелесье гусь 4.d89d5f68.jpg";